export var BackdropCssClass;
(function (BackdropCssClass) {
    BackdropCssClass["Base"] = "iress-backdrop";
    BackdropCssClass["Show"] = "iress-backdrop--show";
    BackdropCssClass["Transparent"] = "iress-backdrop--transparent";
})(BackdropCssClass || (BackdropCssClass = {}));
//# sourceMappingURL=backdrop.types.js.map